<template>
    <ion-toolbar>
        <ion-buttons slot="start"
            v-if="$store.state.pages.auth.back.length || ['profile_pharmacy_certification', 'profile_job_seeker_pharmacy_certification', 'locum_jobseeker_pharmacist_certifications'].includes(routeName)">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end"
            v-if="!['profile_pharmacy_certification', 'profile_job_seeker_pharmacy_certification'].includes(routeName)">
            <ion-button @click="skip" class="pill next-pill-button">
                <span>Skip</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Advanced Credentials</h1>
                    <span>{{ softwarecertificatesCustomFields.length > 0 ? softwarecertificatesCustomFields[0].label
                        :
                        '' }}</span>
                </div>
                <div class="brand-icon">
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
                </div>
            </div>
            <el-form class="full_page" :label-position="'top'"
                @submit.prevent="goNext('userForm', nextPage ? true : false)">
                <template v-if="!nextPage">

                    <el-form-item prop="schedule" class="job_filters_form_checkbox">
                        <div class="item-select__header">
                            <div class="item-select__title">Experience</div>
                        </div>
                        <template v-if="softwarecertificatesCustomFields.length > 0">
                            <template v-for="(field, index) in softwarecertificatesCustomFields" :key="index">
                                <template v-if="field.fieldType === 'MultiSelectcheckboxWithFileUpload'">
                                    <el-checkbox-group v-model="form.selectedValues">
                                        <div v-for="(value, i) in field.values" :key="i">
                                            <el-checkbox :label="value.label"
                                                @change="handleCheckboxChange(value, index)">{{
                                                value.label }}</el-checkbox>
                                            <el-input v-if="isDynamicSelected(value)" v-model="form[value.label]"
                                                :placeholder="`Enter ${value.label}`"
                                                @input="sanitizeInput(value.label)"></el-input>
                                        </div>
                                    </el-checkbox-group>
                                </template>
                                <el-form-item-error v-if="v$.selectedValues.$error">{{
                                    v$.selectedValues.$errors[0].$message
                                    }}</el-form-item-error>
                            </template>
                        </template>
                    </el-form-item>
                    <el-button class="submit" :disabled="isDisabledNext" type="blue" @click="nextStep">
                        Next
                    </el-button>
                </template>
                <template v-else>
                    <div>
                        <div v-for="(selectedValue, index) in form.selectedValues" :key="selectedValue">
                            <div class="upload-label">
                                <div>{{ selectedValue }}</div>
                                <span class="remove-icon" @click.stop="removeSelectedValue(index)">
                                    <i class="el-icon-close"></i>
                                </span>
                            </div> <!-- Display the selected value as title -->


                            <!-- Render el-upload component for each selected value -->
                            <div v-if="checkFileListTempLength(selectedValue)">
                                <el-form-item :show-message="false" label="">
                                    <el-upload class="uploader-support" :action="'upload'"
                                        :v-model:file-list="getFileList(selectedValue)"
                                        :name="getFileList(selectedValue)" list-type="picture" :thumbnail-mode="true"
                                        :limit="1"
                                        :on-preview="(selectedValue, file) => cropperOtherMethods.handlePreview(selectedValue, file)"
                                        :on-exceed="(selectedValue, file, files) => cropperOtherMethods.handleExceed(selectedValue, file, files)"
                                        :drag="true"
                                        :on-change="(file, fileList) => cropperOtherMethods.handleChange(selectedValue, file, fileList)"
                                        :before-upload="(selectedValue, file) => cropperOtherMethods.beforeAvatarUpload(selectedValue, file)">
                                        <svg width="54" height="54" viewBox="0 0 54 54" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M27 4.5V18L31.5 13.5" stroke="black" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M27 18L22.5 13.5" stroke="black" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path
                                                d="M15.75 27C6.75 27 6.75 31.0275 6.75 36V38.25C6.75 44.46 6.75 49.5 18 49.5H36C45 49.5 47.25 44.46 47.25 38.25V36C47.25 31.0275 47.25 27 38.25 27C36 27 35.37 27.4725 34.2 28.35L31.905 30.78C29.25 33.615 24.75 33.615 22.0725 30.78L19.8 28.35C18.63 27.4725 18 27 15.75 27Z"
                                                stroke="black" stroke-width="2" stroke-miterlimit="10"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M11.25 26.9998V17.9998C11.25 13.4773 11.25 9.74234 18 9.08984"
                                                stroke="black" stroke-width="2" stroke-miterlimit="10"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M42.75 26.9998V17.9998C42.75 13.4773 42.75 9.74234 36 9.08984"
                                                stroke="black" stroke-width="2" stroke-miterlimit="10"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        <div class="cv-upload-title">Browse Your Files</div>
                                        <div class="cv-upload-info">You can only upload file with JPG JPEG PNG JFIF SVG
                                            or PDF formats and
                                            also file
                                            maximum size 10MB.</div>
                                        <template #file="{ file }">
                                            <div class="wrap-fd"
                                                style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                                                <div v-if="file.raw.type == 'application/pdf'"
                                                    class="el-upload-list__item-body">
                                                    <!-- <span class="locumate_icons locumate_icon-picture"></span> -->
                                                    <img class="el-upload-list__item-body-thumbnail"
                                                        :src="require('@/assets/img/icons/pdf.svg')" />
                                                    <span class="mx-2" size="large">{{ file.name }}</span>
                                                </div>
                                                <div class="el-upload-list__item-body" v-else>
                                                    <img class="el-upload-list__item-thumbnail" :src="file.url"
                                                        alt="" />
                                                    <span class="mx-2" size="large">{{ file.name }}</span>
                                                </div>
                                                <!-- Remove Button -->
                                                <div class="el-upload-list__item-actions">
                                                    <button class="el-upload-list__item-actions-action"
                                                        @click.prevent="cropperOtherMethods.handleRemove(selectedValue, file)">
                                                        <img :src="require('@/assets/img/icons/trash.svg')" />
                                                    </button>
                                                </div>
                                            </div>
                                        </template>
                                    </el-upload>
                                </el-form-item>
                            </div>
                            <div v-else>
                                <div class="preview_square preview_square-block">
                                    <div class="el-upload-list">
                                        <div class="el-upload-list__item"
                                            v-for="(file, index) in form[getFileListTempLength(selectedValue)]"
                                            :key="file.url">

                                            <div class="thumbnail_img el-upload-list--picture-card">
                                                <div v-if="file.raw.type == 'application/pdf'">
                                                    <img src="@/assets/img/default_pdf.svg" alt=""
                                                        class="header_logo_text">
                                                </div>
                                                <div v-else>
                                                    <img class="el-upload-list__item-thumbnail" :src="file.url"
                                                        alt="" />
                                                </div>
                                                <span class="el-upload-list__item-actions">
                                                    <span class="el-upload-list__item-preview"
                                                        @click="docPreviewModalOpen(file)">
                                                        <i class="el-icon-zoom-in"></i>
                                                    </span>
                                                    <span class="el-upload-list__item-delete"
                                                        @click="fileDelete(file, index, getFileList(selectedValue), getFileListTempLength(selectedValue))">
                                                        <i class="el-icon-delete"></i>
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                    <el-form-item class="button_submit mb0">
                        <el-button :disabled="isSubmitDisabled" class="submit_page submit" type="blue"
                            @click="goNext('userForm')">
                            {{ routeName == 'profile_pharmacy_certification' || routeName ==
                            'profile_job_seeker_pharmacy_certification' ? 'Save' : 'Continue' }}
                        </el-button>
                    </el-form-item>
                </template>
            </el-form>
            <div class="background-circles">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
            </div>
        </div>
    </div>
</template>


<script>
import {
    onMounted,
    inject,
    onBeforeMount,
    ref,
    reactive,
    computed
} from 'vue';

import {
    addIcons
} from 'ionicons'
import {
    arrowBackOutline
} from 'ionicons/icons'
addIcons({
    'arrow-back-outline': arrowBackOutline
})
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from '@ionic/vue';

import {
    useStore
} from 'vuex'
import {
    useRouter,
    useRoute
} from 'vue-router'
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import FileHelpers from "@/helpers/file/file";
import { ElMessage } from "@/components/Vendor/Element";
import { ElMessageBox } from "@/components/Vendor/Element";
import SvgIcon from '@/components/Svg/SvgIcon.vue';
export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        SvgIcon,
    },
    directives: {
    },
    setup() {
        const $store = useStore()
        const $router = useRouter()
        const $route = useRoute()
        const setPageClassGlobal = inject('setPageClassGlobal');
        const routeName = $route.name;
        const fileHelpers = new FileHelpers();
        const softwarecertificatesCustomFields = ref([]);
        const userData = $store.getters.GET_USER_DATA;
        let nextPage = ref(false);
        const form = reactive({
            selectedValues: ref(userData.customFields?.certificates?.map(item => item.value) || []),
            Others: ref(userData.customFields?.certificates?.find(item => item.value === 'Others')?.otherValue || '')
        });


        const rules = computed(() => {
            return {
                selectedValues: { required: helpers.withMessage('', required) },
            };
        });
        const v$ = useVuelidate(rules, form);


        const isDynamicSelected = (value) => {
            return (
                form.selectedValues.includes(value.label) && value.showTextbox === true
            );
        };


        const getUploadName = (selectedValue) => {
            const formattedName = selectedValue.toLowerCase().replace(/\s/g, "_");
            return `${formattedName}_upload`;
        };

        const getFileList = (selectedValue) => {
            const formattedName = selectedValue.toLowerCase().replace(/\s/g, "_");
            const main = `${formattedName}_upload`;
            return computed(() => main);

        };

        const checkFileListTempLength = (selectedValue) => {
            const formattedName = selectedValue.toLowerCase().replace(/\s/g, "_");
            const length = `${formattedName}_length`;
            if (!form[length]) {
                form[length] = ref([]); // Initialize as a ref array
            }

            return form[length].length == 0;

        };

        const getFileListTempLength = (selectedValue) => {
            const formattedName = selectedValue.toLowerCase().replace(/\s/g, "_");
            const tempName = `${formattedName}_length`;
            return tempName;

        };

        // Function to initialize upload fields dynamically based on selected values
        const initializeUploadFields = () => {
            form.selectedValues?.forEach(value => {
                const formattedKey = `${value.toLowerCase().replace(/\s+/g, '_')}_upload`;  // Convert to camelCase
                const temporaryCheckForIfLogic = `${value.toLowerCase().replace(/\s+/g, '_')}_length`;
                if (!form[formattedKey]) {
                    form[formattedKey] = ref([]);  // Initialize if it doesn't already exist
                }
                // Initialize form[temporaryCheckForIfLogic] if it doesn't exist
                if (!form[temporaryCheckForIfLogic]) {
                    form[temporaryCheckForIfLogic] = ref([]); // Initialize as a ref array
                }

                // Find corresponding data in userData and populate if available
                const cert = userData.customFields?.certificates?.find(item => item.value === value && item.file);
                console.log("🚀 ~ initializeUploadFields ~ cert:", cert)
                if (cert) {
                    form[formattedKey].push({
                        id: cert.file.id,
                        name: cert.file.name,
                        url: cert.file.url,
                        raw: {
                            url: cert.file.url,
                            type: `application/${cert.file.fileExtension}`,
                        },
                    });
                    form[temporaryCheckForIfLogic].push({
                        id: cert.file.id,
                        name: cert.file.name,
                        url: cert.file.url,
                        raw: {
                            url: cert.file.url,
                            type: `application/${cert.file.fileExtension}`,
                        },
                    });
                }
            });

        };

        // Call this function to initialize form fields when the component loads
        initializeUploadFields();

        const goNext = async () => {
            const result = await v$.value.$validate();
           
            if(form.selectedValues.length === 0){
                if (routeName == "profile_pharmacy_certification") {
                    $router.push({
                        name: "profile_edit"
                    })
                } else if (routeName == "profile_job_seeker_pharmacy_certification") {
                    $router.push({
                        name: "basic_profile_job_seeker"
                    })
                }else if (routeName == "locum_jobseeker_pharmacist_certifications") {
                    $router.push({
                        name: "locum_jobseeker_cv"
                    })
                }else if (routeName == "auth_internal_pharmacist_certifications") {
                    $router.push({
                        name: "auth_contractor_rate"
                    })
                } else {
                    $router.push({
                        name: "auth_availability_week"
                    })
                }
                return;
            }
            if (!result) {
                alert('The form has errors');
                return;
            } else {



                for (const selectedValue of form.selectedValues) {
                    const formData = new FormData();
                    const otherValue = form[selectedValue] ? form[selectedValue] : "";
                    const fileKey = getUploadName(selectedValue);


                    // If file exists, append file to FormData
                    const files = form[fileKey];
                    formData.append('key', 'certificates');
                    formData.append(`values`, JSON.stringify({ value: selectedValue, other_value: otherValue, file: true }));
                    formData.append(`selectedValues`, form.selectedValues);
                    if (files && files.length > 0) {
                        files.forEach((file) => {
                            formData.append(`file`, file.raw); // Assuming file is already a File object

                        });
                    }
                    try {
                        await $store.dispatch("SAVE_USER_CERFICATIONS_DATA", formData);

                        if (routeName == "profile_pharmacy_certification") {
                            $router.push({
                                name: "profile_edit"
                            })
                        } else if (routeName == "profile_job_seeker_pharmacy_certification") {
                            $router.push({
                                name: "basic_profile_job_seeker"
                            })
                        } else if (routeName == "locum_jobseeker_pharmacist_certifications") {
                            $router.push({
                                name: "locum_jobseeker_cv"
                            })
                        }else if (routeName == "auth_internal_pharmacist_certifications") {
                        $router.push({
                            name: "auth_contractor_rate"
                        })
                        } else {
                            $router.push({
                                name: "auth_availability_week"
                            })
                        }



                    } catch (error) {
                        console.log(error);
                    }

                }



            }
        };

        const skip = () => {
            (async () => {
                // try {
                //     await ElMessageBox.confirm(
                //         ``,
                //         "Do you want to skip? You will be unverified",
                //         {
                //             distinguishCancelAndClose: true,
                //             showConfirmButton: true,
                //             confirmButtonText: "Skip",
                //             cancelButtonText: "Cancel",
                //             confirmButtonClass: "el-button--green",
                //             cancelButtonClass: "el-button--grey",
                //             showClose: true,
                //         }
                //     );
                // } catch {
                //     return;
                // }
                try {
                    if(routeName == 'locum_jobseeker_pharmacist_certifications'){
                        $router.push({
                            name: "locum_jobseeker_cv"
                        })

                    }else if (routeName == "auth_internal_pharmacist_certifications") {
                    $router.push({
                        name: "auth_contractor_rate"
                    })
                    } else{
                        $store.dispatch('addAuthPageBack', $route.name);
                        $router.push({
                            name: 'auth_availability_week',
                        })
                    }
                   
                } catch (error) {
                    console.log(error);
                }
            })();

        }

        const validateField = (fieldName) => {
            // Trigger validation for the specified field
            v$.value[fieldName].$touch();
        };

        onMounted(() => {
            setPageClassGlobal('global_auth_pharmacy_experience_page');

        });

        onBeforeMount(async () => {
            try {
                const response = await $store.dispatch("GET_CUSTOM_FIELDS",);
                softwarecertificatesCustomFields.value = response.data.certificates;
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        });

        const handleCheckboxChange = (value, index) => {
            console.log("🚀 ~ handleCheckboxChange ~ index:", index)
            if (form.selectedValues.includes(value.label)) {
                const transformedString = value.label.toLowerCase().replace(/\s/g, "_");
                const ruleUploadKey = transformedString + '_upload';
                rules.value[ruleUploadKey] = { required };

                // Add the otherInputValue[index] field to the form
                const fieldValue = ref([]);
                form[ruleUploadKey] = ref(fieldValue);

                // Touch the field to trigger validation
                v$.value.$touch(ruleUploadKey);
            } else {
                const transformedString = value.label.toLowerCase().replace(/\s/g, "_");
                const ruleUploadKey = transformedString + '_upload';
                delete rules.value[ruleUploadKey];
                delete form[ruleUploadKey];
            }

            if (value.showTextbox && form.selectedValues.includes(value.label)) {
                const ruleKey = value.label;
                rules.value[ruleKey] = { required };

                // Add the otherInputValue[index] field to the form
                const fieldValue = "";
                form[ruleKey] = ref(fieldValue);

                // Touch the field to trigger validation
                v$.value.$touch(ruleKey);
            } else {
                const ruleKey = value.label;
                delete rules.value[ruleKey];
                delete form[ruleKey];
            }
        };

        console.log("hellooo jshjas", form.selectedValues)
        const isSubmitDisabled = computed(() => {
            // Filter out keys ending in '_length'
            if(form.selectedValues.length === 0){
               return false;
            }

            const filteredValues = Object.keys(form)
                .filter(key => !key.endsWith('_length'))
                .map(key => form[key]);

            // Check if any of the filtered values is an empty array or string
            const hasEmptyValues = filteredValues.some(value =>
                Array.isArray(value) && value.length === 0
            );

            return hasEmptyValues || v$.value.$pending || v$.value.$error;
        });



        // const isDisabledNext = computed(() => {
        //     // Check if "Others" is selected in selectedValues
        //     if (form.selectedValues.length > 0) {
        //         const hasOthersKey = form.selectedValues.includes("Others");

        //         // Ensure that "Others" has a non-empty value if it is selected
        //         const isOthersValid = hasOthersKey ? form.Others !== "" : true;

        //         // Disable the button if selectedValues is empty or "Others" is invalid
        //         return form.selectedValues.length === 0 || !isOthersValid;
        //     } else {
        //         return false;
        //     }

        // });

        const isDisabledNext = computed(() => {
            // Ensure at least one option is selected
            const isOptionSelected = form.selectedValues.length > 0;

            // Check if "Others" is selected and ensure it has a valid value
            const isOthersValid = form.selectedValues.includes("Others") ? form.Others.trim() !== "" : true;

            // Disable the button if no option is selected or "Others" is invalid
            return !isOptionSelected || !isOthersValid;
        });




        const nextStep = () => {

            if (form.selectedValues.length === 0) {
                if (routeName == "profile_pharmacy_certification") {
                    $router.push({
                        name: "profile_edit"
                    })
                } else if (routeName == "profile_job_seeker_pharmacy_certification") {
                    $router.push({
                        name: "basic_profile_job_seeker"
                    })
                }else if (routeName == "auth_internal_pharmacist_certifications") {
                    $router.push({
                        name: "auth_contractor_rate"
                    })
                    } else {
                    $router.push({
                        name: "covid_status"
                    })
                }
            } else {

                nextPage.value = !nextPage.value;
            }

        };

        const goBack = async() => {
            if (nextPage.value) {
                nextPage.value = !nextPage.value;
            } else {
                if (routeName == "profile_pharmacy_certification") {
                    $router.push({
                        name: "profile_edit"
                    })
                } else if (routeName == "locum_jobseeker_pharmacist_certifications") {
                    $router.push({
                        name: "locum_jobseeker_software_experience"
                    })
                } else if (routeName == "profile_job_seeker_pharmacy_certification") {
                    $router.push({
                        name: "basic_profile_job_seeker"
                    })
                }else if (routeName == "auth_internal_pharmacist_certifications") {
                    $router.push({
                        name: "auth_internal_software_experience"
                    })
                    } else {
                    const back = await $store.dispatch("getAuthPageBack");
                    $router.push({
                        name: back,
                    });
                }
            }
        };

        const cropperOtherMethods = {
            beforeAvatarUpload(file) {
                console.log("🚀 ~ beforeAvatarUpload ~ file:", file)
                const image = URL.createObjectURL(file.raw);
                console.log("🚀 ~ beforeAvatarUpload ~ image:", image)
            },

            handleRemove(selectedValue, file) {
                console.log("Selected value:", selectedValue);
                const modelName = getFileList(selectedValue);
                form[modelName.value].splice(form[modelName.value].indexOf(file), 1);
            },

            handleChange(selectedValue, file, fileList) {
                const type = fileHelpers.getFileType(file);
                const modelName = getFileList(selectedValue);
                const fieldNameLength = selectedValue.toLowerCase().replace(/\s/g, '_') + '_length';
                console.log("🚀 ~ removeSelectedValue ~ fieldNameLength:", fieldNameLength)
                if (type == "image" || type == "pdf") {
                    form[modelName.value] = fileList;
                    if (form[fieldNameLength] !== undefined) {
                        delete form[fieldNameLength];
                    }
                    console.log("Selected value fileList:", form[modelName]);
                } else {
                    fileList.pop();
                    form[modelName.value] = null;
                    ElMessage({
                        type: "error",
                        message: `Document must be JPG JPEG PNG JFIF or PDF format!`,
                    });
                }
            },
            handlePreview(selectedValue, file) {
                console.log("🚀 ~ file:", file)
                console.log("Selected value:", selectedValue);
                // Handle preview logic here
            },
            handleExceed(selectedValue, file, files) {
                console.log("🚀 ~ handleExceed ~ files:", files)
                console.log("🚀 ~ handleExceed ~ file:", file)
                console.log("Selected value:", selectedValue);
                ElMessage({
                    type: "error",
                    message: `You can upload 1 document, you selected ${selectedValue.length} `,
                });
            },
        };

        const removeSelectedValue = (index) => {
            const value = form.selectedValues[index];
            if (value === "Others") {
                if (form.Others !== undefined) {
                    delete form.Others;  // Remove the "Others" field
                }
            }
            form.selectedValues.splice(index, 1);

            const fieldName = value.toLowerCase().replace(/\s/g, '_') + '_upload';
            const fieldNameLength = value.toLowerCase().replace(/\s/g, '_') + '_length';
            console.log("🚀 ~ removeSelectedValue ~ fieldNameLength:", fieldNameLength)

            console.log("🚀 ~ removeSelectedValue ~ fieldName:", fieldName)
            if (form[fieldName] !== undefined) {
                delete form[fieldName];
            }
            if (form[fieldNameLength] !== undefined) {
                delete form[fieldNameLength];
            }
        };

        const docPreviewModalOpen = (file) => {
            window.open(file.url, '_blank');
        };

        const fileDelete = async (file, index, type, tempType) => {

            try {
                console.log("deleted files", file);
                console.log("This is the index", index)
                await ElMessageBox.confirm(
                    `Are you sure you’d like to remove file ?`,
                    "Remove file",
                    {
                        confirmButtonText: "Remove",
                        cancelButtonText: "Cancel",
                        confirmButtonClass: "el-button--red",
                        cancelButtonClass: "el-button--grey",
                        showClose: false,
                    }
                );
                await $store.dispatch("DELETE_USER_DOCUMENT", file);
                if (file.id) {
                    form[type.value] = form[type.value].filter(
                        (item) => item.id !== file.id
                    );
                    form[tempType] = form[tempType].filter(
                        (item) => item.id !== file.id
                    );

                }
            } catch (error) {
                console.log(error);
            }
        };

        const sanitizeInput = (label) => {
        // Prevent starting with space and sanitize input
        // Check if the initial character is a space
        if (form[label]?.startsWith(' ')) {
            // If it starts with a space, remove it
            form[label] = form[label].trimStart();
        }
        };

   
    


        return {
            goBack,
            goNext,
            handleCheckboxChange,
            isDynamicSelected,
            softwarecertificatesCustomFields,
            form,
            rules,
            v$,
            validateField,
            isSubmitDisabled,
            nextStep,
            nextPage,
            isDisabledNext,
            getUploadName,
            getFileList,
            cropperOtherMethods,
            removeSelectedValue,
            skip,
            routeName,
            checkFileListTempLength,
            getFileListTempLength,
            docPreviewModalOpen,
            fileDelete,
            sanitizeInput,
        }
    },
}
</script>
